import democratiseImage from 'marketing-website/media/images/pages/consultancies/democratise@2x.jpg';
import feedback from 'marketing-website/media/images/pages/agencies-industry-pages/feedback@2x.jpg';
import hero from 'marketing-website/media/images/pages/agencies-industry-pages/hero@2x.jpg';
import people from 'marketing-website/media/images/pages/agencies-industry-pages/people@2x.jpg';
import userTesting from 'marketing-website/media/images/pages/agencies-industry-pages/user-testing@2x.jpg';
import designThinking from 'marketing-website/media/images/pages/agencies-industry-pages/design-thinking@2x.jpg';

const assets = {
  hero: {
    alt: 'Deliver world class design to your clients, in record time',
    src: hero,
    maxWidth: 647,
  },
  democratise: {
    alt: 'Democratise design by giving every team access to the right tools',
    src: democratiseImage,
    maxWidth: 660,
  },
  feedback: {
    alt: 'Bridge communication gaps with clients',
    src: feedback,
    maxWidth: 647,
  },
  people: {
    alt: 'Speed up time to sign off',
    src: people,
    maxWidth: 570,
  },
  userTesting: {
    alt: 'Test work with internal and external stakeholders',
    src: userTesting,
    maxWidth: 660,
  },
  designThinking: {
    src: designThinking,
    maxWidth: 1200,
  },
};

export default assets;



// WEBPACK FOOTER //
// ./src/configs/pages/agencies-industry-pages/assets.js